function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { guid } from '@bydesign-ui/utils';
import { useUpdate } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { useMenu, useMenuItem } from '../../../hooks/menu';
import { SubMenuContext } from '../../../hooks/menu/context/SubMenu';
import { RcClickTrigger, RcHoverTrigger } from '../../../hooks/popper';
import { useSecondChildExpandAnimation } from '../../../hooks/useSecondChildExpandAnimation';
import { RcPopover } from '../../../units/popover-wrapper';
export function MenuItem(props) {
  var id = props.id,
      icon = props.icon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      children = props.children;

  var _useMenuItem = useMenuItem({
    id: id
  }),
      _useMenuItem2 = _slicedToArray(_useMenuItem, 2),
      item = _useMenuItem2[0],
      active = _useMenuItem2[1];

  var handleClick = useCallback(function () {
    !disabled && item.setActive();
  }, []);
  var menu = useMenu();
  var isMenuDirectChild = Boolean(!useContext(SubMenuContext));

  var _menu$getExtraProps = menu.getExtraProps(),
      collapse = _menu$getExtraProps.collapse,
      theme = _menu$getExtraProps.theme;

  var level = item.getLevel();
  var prefixClsConfig = useCallback(function (active) {
    return _defineProperty({
      active: active
    }, level, true);
  }, []);
  var inActiveMenuItemCls = usePrefixCls('menu-item', prefixClsConfig(false));
  var activeMenuItemCls = usePrefixCls('menu-item', prefixClsConfig(true));
  var menuLineIconCls = usePrefixCls('menu-line-icon');
  var menuLineTitleCls = usePrefixCls('menu-line-title');
  var forceUpdate = useUpdate();
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var trigger = menu.getTrigger();
  var Trigger = trigger === 'click' ? RcClickTrigger : RcHoverTrigger;

  var _React$useState = React.useState(item.opened),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      opened = _React$useState2[0],
      setOpened = _React$useState2[1];

  var popoverCls = usePrefixCls('submenu-popover', _defineProperty({}, theme, true));
  var contentVisibleRef = useRef(!collapse);
  var elementRef = useRef(null);
  var startExpandAnimation = useSecondChildExpandAnimation(elementRef, {
    disabled: collapse && !contentVisibleRef.current,
    expanded: opened
  });
  useEffect(startExpandAnimation, [opened, collapse]);
  useEffect(function () {
    contentVisibleRef.current = !collapse;

    if (collapse) {
      var timeoutId = setTimeout(function () {
        return forceUpdate();
      }, 400);
      return function () {
        return clearTimeout(timeoutId);
      };
    }
  }, [collapse]);
  var paddingLeft = '16px';

  if (!collapse) {
    paddingLeft = "".concat(level * 24, "px");
  }

  var style = {
    paddingLeft: paddingLeft
  };

  var renderContent = function renderContent(show) {
    return React.createElement("div", {
      className: active && !isMenuDirectChild ? activeMenuItemCls : inActiveMenuItemCls,
      onClick: handleClick,
      style: style
    }, !show && icon && React.createElement("span", {
      className: menuLineIconCls
    }, icon), React.createElement("span", {
      className: menuLineTitleCls
    }, children));
  };

  if (!isMenuDirectChild) {
    return renderContent(false);
  }

  var renderHeader = function renderHeader() {
    return React.createElement("div", {
      className: active ? activeMenuItemCls : inActiveMenuItemCls,
      onClick: handleClick,
      style: style
    }, icon && React.createElement("span", {
      className: menuLineIconCls
    }, icon), React.createElement("span", {
      className: menuLineTitleCls
    }, children));
  };

  var hidePopover = function hidePopover() {
    !disabled && setOpened(false);
  };

  var showPopover = function showPopover() {
    !disabled && setOpened(true);
  };

  return React.createElement("div", {
    className: inActiveMenuItemCls,
    style: {
      paddingRight: 0
    },
    ref: elementRef
  }, React.createElement(Trigger, {
    style: {
      width: '100%'
    },
    triggerId: triggerId,
    disabled: !collapse
  }, renderHeader()), React.createElement(RcPopover, {
    lazyInit: true,
    show: collapse && opened,
    getPopper: renderContent(collapse && opened),
    singleGroupId: String(level),
    placement: "right-start",
    triggerIds: triggerIds,
    preventAroundOverflow: true,
    refType: "trigger",
    refId: triggerId,
    offset: {
      x: 4,
      y: 0
    },
    className: popoverCls,
    onHide: hidePopover,
    onShow: showPopover
  }));
}